<template>
  <div>
    <div v-show="tableShow">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="姓名">
          <el-input v-model="searchForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="searchForm.iccard" placeholder="请输入身份证号码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryCertinfo()">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="reset()">显示所有</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="reset()">新增证书</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" border style="width: 100%" @row-click="rowClick">
        <el-table-column fixed prop="serial" label="证书编号" width="130">
        </el-table-column>
        <el-table-column fixed prop="person.name" label="姓名" width="100">
        </el-table-column>
        <el-table-column prop="person.id_number" label="身份证号" width="200">
        </el-table-column>
        <!-- <el-table-column prop="subject" label="任教科1目" width="300" style="display: none">
        </el-table-column> -->
        <el-table-column prop="first_init_time" label="首次领证时间" width="150">
        </el-table-column>
        <el-table-column prop="init_time" label="领证时间" width="150">
        </el-table-column>
        <el-table-column prop="valid_time" label="到期时间" width="150">
        </el-table-column>
        <el-table-column prop="training_record[0].training_time" label="培训时间1" width="150">
        </el-table-column>
        <el-table-column prop="training_record" label="培训时间2" width="150">
          <template slot-scope="scope">
            <p v-if="scope.row.training_record.length>='2'">{{scope.row.training_record[1].training_time}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="training_record" label="培训时间3" width="150">
          <template slot-scope="scope">
            <p v-if="scope.row.training_record.length>='3'">{{scope.row.training_record[2].training_time}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="training_record.length" label="培训次数" width="80">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click.native.prevent="modify(scope.$index, tableData)" type="text" size="small">
              编辑
            </el-button>
            <el-button @click.native.prevent="addTrainRecord(scope.$index, tableData)" type="text" size="small" :disabled="scope.row.training_record.length == 3">
              复训
            </el-button>
            <el-button @click.native.prevent="addTrainRecordAndChangeCert(scope.$index, tableData)" type="text" size="small" :disabled="scope.row.training_record.length <= 2">
              复训换证
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px;margin-bottom:10px" background layout="prev, pager, next" :page-size="12" :total="totalCount" :current-page.sync="currentPage" @next-click="nextPage()" @prev-click="prevPage()" @current-change="changePage()">
      </el-pagination>
    </div>
    <div v-if="appendDialog" style="width: 400px">
      <el-form :model="form">
        <el-form-item label="培训记录1" :label-width="formLabelWidth">
          <el-input v-model="formAppend.time1" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="培训记录2" :label-width="formLabelWidth">
          <el-input v-model="formAppend.time2" v-if="formAppend.time2 != ''" autocomplete="off" :disabled="formAppend.time2 != ''"></el-input>
          <el-date-picker v-else v-model="training_time" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="培训记录3" :label-width="formLabelWidth">
          <el-date-picker v-model="training_time" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" placeholder="选择日期" :disabled="formAppend.time2 == ''" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="理论分数" :label-width="formLabelWidth">
          <el-input-number v-model="score_theory" :min="80" :max="100" style="width: 100%">
          </el-input-number>
        </el-form-item>
        <el-form-item label="实作分数" :label-width="formLabelWidth">
          <el-input-number v-model="score_practice" :min="80" :max="100" style="width: 100%">
          </el-input-number>
        </el-form-item>
        <el-form-item label="培训机构" :label-width="formLabelWidth">
          <el-select v-model="org" filterable placeholder="请选择" style="display: block" value-key="id">
            <el-option v-for="item in orgData" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="appendDialog = false; tableShow = true">取 消</el-button>
        <el-button type="primary" @click="updateCert()">确 定</el-button>
      </div>
    </div>
    <div v-if="changeCert" style="width: 400px">
      <el-form :model="form">
        <el-form-item label="初领日期" :label-width="formLabelWidth">
          <el-input v-model="first_init_time" style="width: 100%" :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="领证日期" :label-width="formLabelWidth">
          <el-input v-model="init_time" style="width: 100%" :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="有效期限" :label-width="formLabelWidth">
          <el-input v-model="valid_time" style="width: 100%" :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="培训时间" :label-width="formLabelWidth">
          <el-date-picker v-model="training_time" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="新领证日期" :label-width="formLabelWidth">
          <el-date-picker v-model="new_init_time" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="新有效期限" :label-width="formLabelWidth">
          <el-date-picker v-model="new_valid_time" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="理论分数" :label-width="formLabelWidth">
          <el-input-number v-model="score_theory" :min="80" :max="100" style="width: 100%">
          </el-input-number>
        </el-form-item>
        <el-form-item label="实作分数" :label-width="formLabelWidth">
          <el-input-number v-model="score_practice" :min="80" :max="100" style="width: 100%">
          </el-input-number>
        </el-form-item>
        <el-form-item label="培训机构" :label-width="formLabelWidth">
          <el-select v-model="org" filterable placeholder="请选择" style="display: block" value-key="id">
            <el-option v-for="item in orgData" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changeCert = false; tableShow = true">取 消</el-button>
        <el-button type="primary" @click="updateAndChangeCert()">确 定</el-button>
      </div>
    </div>
    <div v-if="modifyCert" style="width: 500px">
      <el-form :model="form">
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="currentCert.person.name" style="width: 100%" :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="证书编号" :label-width="formLabelWidth">
          <el-input v-model="serial" style="width: 100%">
          </el-input>
        </el-form-item>
        <!--<el-form-item label="任教科目" :label-width="formLabelWidth">
          <el-select v-model="subject" filterable placeholder="请选择" style="display: block" value-key="id">
            <el-option v-for="item in subjectData" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="初领日期" :label-width="formLabelWidth">
          <el-date-picker v-model="first_init_time" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="领证日期" :label-width="formLabelWidth">
          <el-date-picker v-model="init_time" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="有效期限" :label-width="formLabelWidth">
          <el-date-picker v-model="valid_time" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="培训时间1" :label-width="formLabelWidth">
          <el-date-picker v-model="training_time_1" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%" :disabled="training_time_1 === ''">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="培训时间2" :label-width="formLabelWidth">
          <el-date-picker v-model="training_time_2" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%" :disabled="training_time_2 === ''">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="培训时间3" :label-width="formLabelWidth">
          <el-date-picker v-model="training_time_3" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%" :disabled="training_time_3 === ''">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所属机构" :label-width="formLabelWidth">
          <el-select v-model="org" filterable placeholder="请选择" style="display: block" value-key="id">
            <el-option v-for="item in orgData" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="打印卡片" :label-width="formLabelWidth">
          <el-checkbox v-model="is_need_sync" style="width: 100%;text-align:left">是否需要重打卡</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modifyCert = false; tableShow = true">取 消</el-button>
        <el-button type="primary" @click="modifyCertData()">确 定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  let Base64 = require('js-base64').Base64;
  export default {
    data() {
      return {
        tableData: [],
        orgData: [],
        subjectData: [],
        org: '',
        score_theory: 80,
        score_practice: 80,
        init_time: '',
        new_init_time: '',
        valid_time: '',
        new_valid_time: '',
        first_init_time: '',
        training_time_1: '',
        training_time_2: '',
        training_time_3: '',
        is_need_sync: false,
        subject: '',
        serial: '',
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
        formAppend: {
          time1: '',
          time2: '',
          time3: ''
        },
        searchForm: {
          name: '',
          iccard: ''
        },
        totalCount: 1000,
        currentPage: 1,
        currentCert: {},
        training_time: '',
        appendDialog: false,
        modifyDialog: false,
        changeCert: false,
        modifyCert: false,
        tableShow: true,
        formLabelWidth: '120px'
      }
    },
    methods: {
      rowClick(row, column, event) {
        console.log(row)
        this.currentCert = row
      },
      modify(index, row) {
        console.log(index);
        let username = localStorage.getItem('username')
        if (username != "teacher") {
          this.$message.error({
            message: '当前账户非一级管理员，不支持修改证书',
            center: true
          });
          return
        }
        this.modifyCert = true;
        this.tableShow = false;
        this.init_time = row[index].init_time
        this.valid_time = row[index].valid_time
        this.first_init_time = row[index].first_init_time
        this.serial = row[index].serial
        this.subject = row[index].subject
        this.org = row[index].organization
        this.training_time_1 = row[index].training_record[0].training_time
        if (row[index].training_record.length >= 2) {
          this.training_time_2 = row[index].training_record[1].training_time
        } else {
          this.training_time_2 = ''
        }
        if (row[index].training_record.length == 3) {
          this.training_time_3 = row[index].training_record[2].training_time
        } else {
          this.training_time_3 = ''
        }
      },
      addTrainRecord(index, row) {
        console.log(index)
        var serial = this.tableData[index].serial;
        this.formAppend.time1 = ''
        this.formAppend.time2 = ''
        this.formAppend.time3 = ''
        this.formAppend.time1 = row[index].training_record[0].training_time
        if (row[index].training_record.length >= 2) {
          this.formAppend.time2 = row[index].training_record[1].training_time
        }
        if (row[index].training_record.length == 3) {
          this.formAppend.time3 = row[index].training_record[2].training_time
        }
        this.appendDialog = true;
        this.tableShow = false;
        this.org = row[index].organization
      },
      addTrainRecordAndChangeCert(index, row) {
        this.changeCert = true;
        this.tableShow = false;
        this.init_time = row[index].init_time
        this.valid_time = row[index].valid_time
        this.first_init_time = row[index].first_init_time
        this.org = row[index].organization
      },
      nextPage() {
        this.currentPage = this.currentPage + 1
        this.$http
          .get('http://120.27.221.176/backend/api/v1/training/certificate/?page=' + this.currentPage)
          .then(response => {
            this.tableData = response.data.results
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '查询失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      },
      prevPage() {
        this.currentPage = this.currentPage - 1
        this.$http
          .get('http://120.27.221.176/backend/api/v1/training/certificate/?page=' + this.currentPage)
          .then(response => {
            this.tableData = response.data.results
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '查询失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      },
      changePage() {
        this.$http
          .get('http://120.27.221.176/backend/api/v1/training/certificate/?page=' + this.currentPage)
          .then(response => {
            this.tableData = response.data.results
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '查询失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      },
      reset: function () {
        this.$http
          .get('http://120.27.221.176/backend/api/v1/training/certificate/?page=' + this.currentPage)
          .then(response => {
            this.tableData = response.data.results
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '查询失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      },
      queryCertinfo: function () {
        var user = this.searchForm.name.replace(/^\s+|\s+$/gm, '');
        var cardId = this.searchForm.iccard.replace(/^\s+|\s+$/gm, '')
        var query = user + '#' + cardId;
        this.$http
          .get('http://120.27.221.176/backend/api/v1/training/certificate/fuzzy_lookup/' + encodeURIComponent(query) + '/?format=json')
          .then(response => {
            console.log(response.data);
            this.tableData = response.data
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '查询失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      },
      updateTrain(train_id, train_time) {
        console.log('update ' + train_id + ' time to ' + train_time)
        let jsondata = {}
        jsondata["training_time"] = train_time
        this.$http
          .patch('http://120.27.221.176/backend/api/v1/training/training_record/' + train_id + '/', jsondata)
          .then(response => {

          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {

          });
      },
      modifyCertData: function () {
        console.log(this.currentCert)
        //var id = parseInt(this.currentCert.serial.substring(this.currentCert.serial.length - 5))
        var id = this.currentCert.id
        var jsondata = {}
        if (this.serial != this.currentCert.serial) {
          jsondata["serial"] = this.serial
        }
        if (this.subject.name != this.currentCert.subject) {
          jsondata["subject"] = this.subject.id
          if (typeof (jsondata["subject"]) == 'undefined') {
            delete jsondata["subject"];
          }
        }
        if (this.init_time != this.currentCert.init_time) {
          jsondata["init_time"] = this.init_time
        }
        if (this.first_init_time != this.currentCert.first_init_time) {
          jsondata["first_init_time"] = this.first_init_time
        }
        if (this.valid_time != this.currentCert.valid_time) {
          jsondata["valid_time"] = this.valid_time
        }
        if (this.org.name != this.currentCert.organization) {
          jsondata["organization"] = this.org.id
          if (typeof (jsondata["organization"]) == 'undefined') {
            console.log("remove org")
            delete jsondata["organization"];
          }
        }
        if (this.is_need_sync) {
          jsondata["is_need_sync"] = true
          jsondata["card"] = null
        }
        if (this.training_time_1 != this.currentCert.training_record[0].training_time) {
          if (this.training_time_1 == null) {
            jsondata["training_record_1"] = null;
            console.log('delete train_1 time')
          } else {
            console.log('update train_1 time')
            this.$options.methods.updateTrain.call(this, this.currentCert.training_record[0].id, this.training_time_1)
          }
        }
        if (this.currentCert.training_record.length >= 2 && this.training_time_2 != this.currentCert.training_record[1].training_time) {
          console.log('op train 2')
          if (this.training_time_2 == null) {
            jsondata["training_record_2"] = null;
            console.log('delete train_2 time')
          } else {
            console.log('update train_2 time')
            this.$options.methods.updateTrain.call(this, this.currentCert.training_record[1].id, this.training_time_2)
          }
        }
        if (this.currentCert.training_record.length >= 3 && this.training_time_3 != this.currentCert.training_record[2].training_time) {
          if (this.training_time_3 == null) {
            jsondata["training_record_3"] = null;
            console.log('delete train_3 time')
          } else {
            console.log('update train_3 time')
            this.$options.methods.updateTrain.call(this, this.currentCert.training_record[2].id, this.training_time_3)
          }
        }
        console.log(jsondata)
        this.modifyCert = false
        this.tableShow = true
        this.$http
          .patch('http://120.27.221.176/backend/api/v1/training/certificate/' + id + '/', jsondata)
          .then(response => {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '修改失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      },
      updateCert: function () {
        console.log(this.org)
        let orgname = this.org
        let orgitem = null
        this.orgData.find(function(value) {
          if(value.name === orgname) {
            console.log("value " + value.name)
            orgitem = value
          }
        })
        //var id = parseInt(this.currentCert.serial.substring(this.currentCert.serial.length - 5))
        var id = this.currentCert.id
        var person_id = this.currentCert.person.id
        var training_time = this.training_time
        var score_theory = this.score_theory
        var score_practice = this.score_practice
        console.log(training_time)
        console.log(score_practice)
        var jsondata = {
          "person": person_id,
          "organization": orgitem.id,
          "score_theory": score_theory,
          "score_practice": score_practice,
          "training_time": training_time
        };
        this.appendDialog = false
        this.tableShow = true
        this.$http
          .post('http://120.27.221.176/backend/api/v1/training/training_record/', jsondata)
          .then(response => {
            var create_id = response.data.id
            if (this.currentCert.training_record.length === 1) {
              jsondata = {
                "id": id,
                "training_record_2": create_id
              }
            } else {
              jsondata = {
                "id": id,
                "training_record_3": create_id
              }
            }
            this.$http
              .patch('http://120.27.221.176/backend/api/v1/training/certificate/' + id + '/', jsondata)
              .then(response => {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
              })
              .catch(error => {
                console.log(error)
                this.$message.error({
                  message: '查询失败，请重试',
                  center: true
                });
              })
              .finally(() => {

              });
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '查询失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      },
      updateAndChangeCert: function () {
        console.log(this.org)
        let orgname = this.org
        let orgitem = null
        this.orgData.find(function(value) {
          if(value.name === orgname) {
            console.log("value " + value.name)
            orgitem = value
          }
        })
        // var id = parseInt(this.currentCert.serial.substring(this.currentCert.serial.length - 5))
        var id = this.currentCert.id
        var person_id = this.currentCert.person.id
        var training_time = this.training_time
        var score_theory = this.score_theory
        var score_practice = this.score_practice
        var init_time = this.new_init_time
        var valid_time = this.new_valid_time
        console.log(training_time)
        console.log(score_practice)
        var jsondata = {
          "person": person_id,
          "organization": orgitem.id,
          "score_theory": score_theory,
          "score_practice": score_practice,
          "training_time": training_time
        };
        this.appendDialog = false
        this.tableShow = true
        this.$http
          .post('http://120.27.221.176/backend/api/v1/training/training_record/', jsondata)
          .then(response => {
            var create_id = response.data.id
            jsondata = {
              "id": id,
              "training_record_1": create_id,
              "training_record_2": null,
              "training_record_3": null,
              "is_need_sync": true,
              "card": null,
              "init_time": init_time,
              "valid_time": valid_time
            }
            this.$http
              .patch('http://120.27.221.176/backend/api/v1/training/certificate/' + id + '/', jsondata)
              .then(response => {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
              })
              .catch(error => {
                console.log(error)
                this.$message.error({
                  message: '查询失败，请重试',
                  center: true
                });
              })
              .finally(() => {

              });
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '查询失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      }
    },
    mounted: function () {
      this.$http
        .get('http://120.27.221.176/backend/api/v1/training/certificate/')
        .then(response => {
          // console.log(response.data)
          this.tableData = response.data.results
          this.totalCount = response.data.count
        })
        .catch(error => {
          console.log(error)
          this.$message.error({
            message: '查询失败，请重试',
            center: true
          });
        })
        .finally(() => {

        });
      if (this.orgData.length === 0) {
        this.$http
          .get('http://120.27.221.176/backend/api/v1/basic/organization/')
          .then(response => {
            this.orgData = response.data
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '查询失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      }
      if (this.subjectData.length === 0) {
        this.$http
          .get('http://120.27.221.176/backend/api/v1/basic/certificate_subject/?page=1&capacity=100')
          .then(response => {
            this.subjectData = response.data.results
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '查询失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      }
    }
  }
</script>
<style scoped>
  my-el-dialog {
    border: black;
    box-shadow: 0 0px 1px rgba(0, 0, 0, .3);
  }
</style>



// WEBPACK FOOTER //
// src/components/CertManage.vue